import * as Types from '@trello/graphql/generated';

import { useQuickLoad } from '@trello/quickload';
import type { TrelloQueryHookOptions, TrelloLazyQueryHookOptions, TrelloSuspenseQueryHookOptions } from '@trello/quickload';
import DocumentNode from '@trello/graphql/documentNode';
import * as Apollo from '@apollo/client';
export const PowerUpPageNavigationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PowerUpPageNavigation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idPlugin"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plugin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idPlugin"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"icon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"iframeConnectorUrl"}},{"kind":"Field","name":{"kind":"Name","value":"listings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"public"}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"PowerUpPageNavigation","document":PowerUpPageNavigationDocument}} as const;
export type PowerUpPageNavigationQueryVariables = Types.Exact<{
  idPlugin: Types.Scalars['ID']['input'];
}>;


export type PowerUpPageNavigationQuery = (
  { __typename: 'Query' }
  & { plugin?: Types.Maybe<(
    { __typename: 'Plugin' }
    & Pick<Types.Plugin, 'id' | 'iframeConnectorUrl' | 'name' | 'public'>
    & { icon: (
      { __typename: 'Plugin_Icon' }
      & Pick<Types.Plugin_Icon, 'url'>
    ), listings?: Types.Maybe<Array<(
      { __typename: 'Plugin_Listings' }
      & Pick<Types.Plugin_Listings, 'id' | 'locale' | 'name'>
    )>> }
  )> }
);

/**
 * __usePowerUpPageNavigationQuery__
 *
 * To run a query within a React component, call `usePowerUpPageNavigationQuery` and pass it any options that fit your needs.
 * When your component renders, `usePowerUpPageNavigationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePowerUpPageNavigationQuery({
 *   variables: {
 *      idPlugin: // value for 'idPlugin'
 *   },
 * });
 */
export function usePowerUpPageNavigationQuery(
  baseOptions: TrelloQueryHookOptions<
    PowerUpPageNavigationQuery,
    PowerUpPageNavigationQueryVariables
  > &
    (
      | { variables: PowerUpPageNavigationQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const isQuickLoading = useQuickLoad({
    waitOn: baseOptions?.waitOn || ['None'],
    document: PowerUpPageNavigationDocument,
    skip: baseOptions?.skip,
  });
  const options = {
    ...defaultOptions,
    ...baseOptions,
    skip: isQuickLoading || baseOptions?.skip,
  };
  const result = Apollo.useQuery<
    PowerUpPageNavigationQuery,
    PowerUpPageNavigationQueryVariables
  >(PowerUpPageNavigationDocument, options);
  // reconstruct result because modifying the useQuery result actually changes apollo behavior because of memoization
  const trelloResult = { ...result };
  if (isQuickLoading) {
    trelloResult.loading = true;
  }

  return trelloResult;
}
export function usePowerUpPageNavigationLazyQuery(
  baseOptions?: TrelloLazyQueryHookOptions<
    PowerUpPageNavigationQuery,
    PowerUpPageNavigationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PowerUpPageNavigationQuery,
    PowerUpPageNavigationQueryVariables
  >(PowerUpPageNavigationDocument, options);
}
export function usePowerUpPageNavigationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | TrelloSuspenseQueryHookOptions<
        PowerUpPageNavigationQuery,
        PowerUpPageNavigationQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PowerUpPageNavigationQuery,
    PowerUpPageNavigationQueryVariables
  >(PowerUpPageNavigationDocument, options);
}
export type PowerUpPageNavigationQueryHookResult = ReturnType<
  typeof usePowerUpPageNavigationQuery
>;
export type PowerUpPageNavigationLazyQueryHookResult = ReturnType<
  typeof usePowerUpPageNavigationLazyQuery
>;
export type PowerUpPageNavigationSuspenseQueryHookResult = ReturnType<
  typeof usePowerUpPageNavigationSuspenseQuery
>;
export type PowerUpPageNavigationQueryResult = Apollo.QueryResult<
  PowerUpPageNavigationQuery,
  PowerUpPageNavigationQueryVariables
>;
